module.exports = __webpack_public_path__ + "img/831d0082d6488d480ac47c11da28b435.png";